import "@/components/app.scss";
import "@/lib/svg-sprite";
import "@/widgets/toggle";
import "@/widgets/slider";

import init from "@/lib/init";

window.addEventListener("DOMContentLoaded", () => init(window.GROW, {}));
